export const FEATURE_NAMESPACE = 'feature.refractory-materials'
